import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Button, FormControl, Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import moment from 'moment';

import CustomPagination from '../../../CustomPagination/CustomPagination';
import Link from '../../../Link/Link';

import messages from '../../../../locale/messages';
import debounce from '../../../../helpers/debounce';
import deleteUser from '../../../../actions/siteadmin/deleteUser';
import updateShopStatus from '../../../../actions/siteadmin/ManageShop/updateShopStatus';
import { capitalizeFirstLetter } from '../../../../helpers/capitalizeFirst';
import { getReadOnlyUsers } from '../../../../helpers/admin/getReadOnlySection';

import EditIcon from '../../../../../public/Icons/edit.png';
import TrashIcon from '../../../../../public/Icons/bin.svg';
import ExportImage from '../../../../../public/Icons/export.png';

import s from './UsersList.css';

class UsersList extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      currentPage: 1,
      keyword: ''
    };
  }

  handleKeywordSearch = debounce((keyword) => {
    const { usersDetails: { refetch }, requestType } = this.props;
    let variables = {
      currentPage: 1,
      keyword,
      requestType
    };
    this.setState({ keyword, currentPage: 1 });
    refetch(variables);
  });

  handleDelete = async (id) => {
    const { deleteUser, usersDetails: { refetch, getAllUsers }, requestType } = this.props;
    const { keyword, currentPage } = this.state;
    let userType = (requestType === 'drivers') ? 2 : 1;
    const deleteUserResponse = await deleteUser(id, userType);
    if (deleteUserResponse?.status === 200) {
      let variables = { currentPage: currentPage > 1 && getAllUsers?.results?.length == 1 ? currentPage - 1 : currentPage, keyword, requestType };
      this.setState({ currentPage: variables.currentPage });
      refetch(variables);
    }
  };

  paginationData = (currentPage) => {
    const { usersDetails: { refetch }, requestType } = this.props;
    const { keyword } = this.state;
    let variables = { currentPage, keyword, requestType };
    this.setState({ currentPage });
    refetch(variables);
  };

  handleStatus = async (updateField, id, status, currentPage) => {
    const { updateShopStatus, usersDetails: { refetch }, requestType } = this.props;
    const { keyword } = this.state;
    let variables = { currentPage, keyword, requestType };
    await updateShopStatus(updateField, id, status, currentPage, requestType == 'drivers' ? 2 : 1);
    refetch(variables);
  };

  render() {
    const { usersDetails, usersDetails: { getAllUsers }, requestType } = this.props;
    const { formatMessage } = this.props.intl;
    const { currentPage, keyword } = this.state;
    const { privileges, readOnlyUser } = this.props

    let exportType = 'users', pageType = 'users/';
    let paginationLabel = formatMessage(messages.eaters);
    if (requestType === 'drivers') {
      exportType = 'drivers';
      pageType = 'drivers/';
      paginationLabel = formatMessage(messages.drivers);
    }

    const isReadOnly = getReadOnlyUsers({ privileges, readOnlyUser, pageType: `/siteadmin/${pageType}` });

    return (
      <div className={cx(s.widthInner, s.tableSection, 'whiteDropdown', 'widthInnerNoBorder')}>
        <div className={cx(s.exportDisplay, s.tabelExport)}>
          <div>
            <div className={s.searchInput}>
              <FormControl type='text' placeholder={formatMessage(messages.search)}
                onChange={(event) => this.handleKeywordSearch(event.target && event.target.value)}
                className={s.formControlInput} />
            </div>
          </div>
          <div className={cx(s.exportTextSection, 'textAlignLeftRTL')}>
            {
              usersDetails && getAllUsers && getAllUsers?.count > 0 && <a
                href={`/export-admin-data?type=${exportType}&keyword=${keyword}`}
                className={cx(s.exportText)}>
                <span className={cx(s.vtrMiddle, s.exportText, 'exportTextRTL')}><FormattedMessage {...messages.exportDataIntoCSV} /></span>
                <span className={s.vtrTextBottom}>
                  <img src={ExportImage} className={s.exportImg} />
                </span>
              </a>
            }
          </div>
        </div>
        <div className={cx(s.tableCss, 'tableCss', 'tableSticky', 'NewAdminResponsiveTable')}>
          <Table className="table">
            <thead>
              <tr>
                <th scope="col"><FormattedMessage {...messages.id} /></th>
                <th scope="col"><FormattedMessage {...messages.firstName} /></th>
                <th scope="col"><FormattedMessage {...messages.lastName} /></th>
                <th scope="col"><FormattedMessage {...messages.email} /></th>
                <th scope="col"><FormattedMessage {...messages.country} /></th>
                <th scope="col"><FormattedMessage {...messages.phoneNumber} /></th>
                <th scope="col"><FormattedMessage {...messages.createdAt} /></th>
                {requestType === 'drivers' && <th scope="col"><FormattedMessage {...messages.userStatus} /></th>}
                <th scope="col"><FormattedMessage {...messages.banStatus} /></th>
                {
                  !isReadOnly &&
                  <>
                    <th scope="col"><FormattedMessage {...messages.action} /></th>
                    <th scope="col"><FormattedMessage {...messages.deleteAction} /></th>
                  </>
                }
              </tr>
            </thead>
            <tbody>
              {
                usersDetails && getAllUsers && getAllUsers?.count > 0 && getAllUsers?.results && getAllUsers?.results?.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td data-label={formatMessage(messages.id)}>{item.profile?.profileId}</td>
                      <td data-label={formatMessage(messages.firstName)}>{item.profile && capitalizeFirstLetter(item.profile.firstName)}</td>
                      <td data-label={formatMessage(messages.lastName)}>{item.profile && capitalizeFirstLetter(item.profile.lastName)}</td>
                      <td data-label={formatMessage(messages.email)}>{item.email}</td>
                      <td data-label={formatMessage(messages.country)}>{item.profile && item.profile.country}</td>
                      <td data-label={formatMessage(messages.phoneNumber)}>{item.phoneDialCode + item.phoneNumber}</td>
                      <td data-label={formatMessage(messages.createdAt)}>{item.createdAt && moment(item.createdAt).format('DD-MM-YYYY HH:mm:ss')}</td>
                      {requestType === 'drivers' && <td data-label={formatMessage(messages.userStatus)}>
                        <select value={item.userStatus} onChange={(e) => { this.handleStatus('userStatus', item.id, e.target.value, currentPage) }} className={s.selectInput}>
                          <option value={'pending'}>{formatMessage(messages.pending)}</option>
                          <option value={'active'}>{formatMessage(messages.approve)}</option>
                          <option value={'inactive'}>{formatMessage(messages.decline)}</option>
                        </select>
                      </td>}
                      <td data-label={formatMessage(messages.banStatus)}>
                        <select value={item.isBan} onChange={(e) => { this.handleStatus('isBan', item.id, e.target.value, currentPage) }} className={s.selectInput}>
                          <option value={1}>{formatMessage(messages.ban)}</option>
                          <option value={0}>{formatMessage(messages.permit)}</option>
                        </select>
                      </td>

                      {
                        !isReadOnly && <>
                          <td data-label={formatMessage(messages.action)}>
                            <Link to={`/siteadmin/${pageType}${item.profile?.profileId}`} className={'editAlignIcon'}>
                              <span><img src={EditIcon} className={cx(s.editIcon, 'editIconRTL')} /></span>
                              <span className={s.vtrMiddle}>
                                <FormattedMessage {...messages.editAction} />
                              </span>
                            </Link>
                          </td>
                          <td className={s.trashPadding} data-label={formatMessage(messages.deleteAction)}>
                            <Button onClick={() => this.handleDelete(item.id, currentPage)} className={s.iconBtn}>
                              <img src={TrashIcon} className={cx(s.editIcon, 'editIconRTL')} />
                              <span className={s.vtrMiddle}>
                                <FormattedMessage {...messages.deleteAction} />
                              </span>
                            </Button>
                          </td>
                        </>
                      }

                    </tr>
                  )
                })
              }
              {
                usersDetails && getAllUsers && getAllUsers?.count === 0 && <tr>
                  <td colSpan={50} className={s.noRecords}><FormattedMessage {...messages.noResult} /></td>
                </tr>
              }
            </tbody>
          </Table>
        </div>
        {
          usersDetails && getAllUsers && getAllUsers?.count > 0 && <div className={cx(s.space5, s.spaceTop5)}>
            <CustomPagination
              total={getAllUsers.count}
              currentPage={currentPage}
              defaultCurrent={1}
              defaultPageSize={10}
              change={this.paginationData}
              paginationLabel={paginationLabel}
            />
          </div>
        }
      </div >
    );
  }
}

const mapDispatch = {
  deleteUser,
  updateShopStatus
};
const mapState = (state) => ({
  privileges: state.commonSettings.privileges,
  readOnlyUser: state.account.privileges.isReadOnly
});

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(UsersList)));